export { default } from './ViewProtocolTemplates';
